export const formatNumberWithSpaces = (value?: string | number) => {
  if (!value || value === '0' || typeof Number(value) !== 'number') return value;

  return new Intl.NumberFormat('ru-RU').format(Number(value));
};
